export const BLANK_LAYOUT = 'blanklayout';
export const BLANK_MOBILE_LAYOUT = 'blankmobilelayout';
export const DEFAULT_LAYOUT = 'defaultlayout';
